import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/git': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M18.8 221.7C18.8 247 35 281.7 60.3 290.2V291.2C41.5 299.5 36.3 341.8 61.3 357V358C34 367 16 384.3 16 414.2 16 465.7 64.8 480 107.5 480 159.5 480 198.2 461.3 198.2 404 198.2 333.5 97.2 359.5 97.2 321.2 97.2 307.7 104.4 302.5 116.9 299.9 158.4 292.2 184.4 259.9 184.4 217.7 184.4 210.4 182.9 203.5 180.4 196.7 187.1 195.2 193.6 193.4 200.1 191.2V140.7C182.9 147.5 164.4 152.5 145.6 152.5 91.8 121.5 18.8 153.8 18.8 221.7zM106.5 385.5C123.5 385.5 147.7 388.5 147.7 410.5 147.7 432.3 128.2 436.8 110 436.8 92.7 436.8 66.7 434.1 66.7 411.6 66.8 389.3 88.8 385.5 106.5 385.5zM103.3 256C81.3 256 72 243 72 222.2 72 172.9 133 173.4 133 221.7 133 242 125 256 103.3 256zM432 305.5V354.5C418.7 361.8 401.5 364.3 386.5 364.3 333 364.3 326.7 322.1 326.7 278.6V190.9H327.2V189.9C320.2 189.9 319.9 188.3 303.2 190.9V143.4H327.2C327.2 121.1 327.5 112.4 325.7 102.2H382.4C380.4 116 380.9 129.7 380.9 143.4H431.9V190.9S412.6 189.9 380.9 189.9V281C380.9 295.8 384.2 313.8 402.7 313.8 412.5 313.8 424 311 432 305.5zM286 68.7C286 87.4 271.5 104.9 252.2 104.9 232.4 104.9 217.7 87.7 217.7 68.7 217.7 49.4 232.2 32 252.2 32 272 32 286 50 286 68.7zM279.8 143.2C278 157.8 278.2 343 279.8 361H224.3C225.9 342.9 226.1 158 224.3 143.2H279.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/git.js
// module id = AnjA
// module chunks = 144